export default __webpack_public_path__ + "static/avatar-kortical-team-911fa924c1bd61a072a978babbc88d6a.png";